import { createContext, useContext } from 'react';

/**
 * Chat id made available to deeply nested renderers (MarkdownBlock images)
 * so they can resolve sandbox file paths (/home/user/…) into presigned URLs
 * via /api/sandbox/files/download. Undefined outside an authenticated chat
 * (share page, audio chat) — sandbox paths render as a placeholder there.
 */
export const SandboxChatIdContext = createContext<string | undefined>(
  undefined,
);

export function useSandboxChatId(): string | undefined {
  return useContext(SandboxChatIdContext);
}
